<template>
    <div class="menu-box">
        <ul class="link-ul">
            <li 
            class="linkItem-li" 
            v-for="(item,i) in linkList"
            :key="i"
            :class="{'linkItem_active':active === item.value,'topBar_menu':type==='topBarMenu'}" 
            @click="linkTo(item.value)">
                {{item.label}}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name:'RMenu',
    props:{
        linkList: {
            type: Array,
            default: () => {
                return []
            }
        },
        active: {
            type: Number,
            default: () => {
                return 1
            }
        },
        type: {
            type: String,
            default: () => {
                return ''
            }
        },
        showMoreFlag:{
            type:Boolean,
            default: () => {
                return true
            }
        }
    },
    methods: {
        linkTo(key){
            this.$emit('linkTo',key)
        }
    },
}
</script>

<style lang="scss" scoped>
    .menu-box{
        height: 64px;
        margin-left: auto !important;
        float: right;
        .link-ul{
            height: 100%;
            display: flex;
            align-items: center;
            margin: 0 auto;
            // border-bottom: 2px solid #494744;
            .linkItem-li {
                transition: all .3s;
                display: flex;
                align-items: center;
                height: 100%;
                cursor: pointer;
                font-size: 15px;
                color: #FFFFFF;
                margin-right: 30px;
                position: relative;
                &::after{
                    position: absolute;
                    content: ' ';
                    transition: all .4s;
                    width: 0%;
                    height: 2px;
                    background-color: #f8a4ae;
                    bottom: -2px;
                    left: 50%;
                    border-radius: 5px;
                }
            }
            .linkItem_active{
                position: relative;
                color: #f8a4ae;
                font-weight: bold;
                &::after{
                    left: 2.5%;
                    width: 95%;
                }
            }
        }
        .topBar_menu{
            &::after{
                bottom: 0 !important;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/r-menu.vue